import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FinishEffectsService } from './finish_effects.service';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../../../app_state';
import { finish } from './finish_actions_creator';

@Injectable()
export class FinishEffects {

  saveData = createEffect(() => this.action$.pipe(
    ofType(finish),
    concatMap(action => of(action).pipe(withLatestFrom(this.store$))),
    map(([_, state]) => {
      let finishState = state['app']['signup']['finish'];
      this.finishEffectService.finishRegistration(finishState);
    })),
    {
      dispatch: false
    });


  constructor(private action$: Actions,
              private store$: Store<IAppState>,
              private finishEffectService: FinishEffectsService
  ) {}
}
